<app-loading-spinner *ngIf="isLoading" />

<div class="w-full min-h-screen overflow-x-auto">

    <div *ngIf="this.logingRole === 'Distribution Centre Head'"
        class="text-[#030308] font-[500] dark:text-white whitespace-nowrap">{{regCode}} {{centerName}}</div>

    <p class="text-[#030308] font-[500] dark:text-white whitespace-nowrap mt-1">
        All Rows ({{ (rows.length || 0).toString().padStart(2, '0') }})
    </p>


    <!-- Row list -->
    <div *ngIf="hasData" class="flex flex-col gap-3 mt-6 w-full">
        <div *ngFor="let row of rows"
            class="flex items-start justify-between gap-4 border-2 border-[#C3CEDA] dark:border-[#2A2A2A] rounded-lg px-4 py-3">

            <div class="flex items-center gap-6 flex-1">

                <!-- Row Number -->
                <div class="flex flex-col items-center self-center shrink-0">
                    <p class="font-[500] text-center text-[#030308] dark:text-white">
                        Row {{ formatRowNo(row.rowIndex) }}
                    </p>

                    <p class="text-xs text-center font-[400] px-1.5 rounded-lg bg-[#E3E9EF]" [ngClass]="row.isEnabled
                ? 'text-[#415CFF]'
                : 'text-[#57687B] dark:text-gray-500'">
                        {{ row.isEnabled ? 'Enabled' : 'Disabled' }}
                    </p>
                </div>


                <!-- Separator + QR/QC -->
                <div class="border-l-2 border-[#C3CEDA] dark:border-[#819BBA] h-10 self-center shrink-0"></div>

                <div class="flex flex-wrap gap-2 max-w-[776px]">
                    <span *ngFor="let pos of getOrderedPositions(row)"
                        class="relative font-[500] rounded-md border-2 flex items-center justify-center w-12 h-9 shrink-0"
                        [ngClass]="[getPositionClass(pos.pType), pos.pType === 'NOR' ? 'group cursor-pointer hover:bg-red-500 hover:border-red-500 hover:text-white' : '']"
                        (click)="pos.pType === 'NOR' && openDeletePositionModal(row, pos)">
                        <span class="group-hover:opacity-60">{{ getPositionLabel(pos) }}</span>
                        <span *ngIf="pos.pType === 'NOR'"
                            class="hidden group-hover:block absolute left-1/2 top-1/2 -translate-x-1/2 -translate-y-1/2 w-4 h-[3px] bg-white rounded-full pointer-events-none">
                        </span>
                    </span>
                </div>

            </div>


            <div class="flex items-center gap-5 self-center">

                <!-- Plus Button -->
                <button type="button"
                    class="flex items-center justify-center w-7 h-7 bg-[#415CFF] text-white rounded-md hover:bg-[#324ae0]"
                    (click)="openCreatePositionModal(row)">
                    <i class="fa-solid fa-plus text-xs"></i>
                </button>


                <!-- Separator + Toggle -->
                <div class="border-l-2 border-[#C3CEDA] dark:border-[#819BBA] h-10"></div>


                <!-- Toggle -->
                <button type="button"
                    class="relative w-11 h-6 rounded-full cursor-pointer transition-colors after:content-[''] after:absolute after:top-[2px] after:start-[2px] after:bg-white after:border after:border-gray-300 after:rounded-full after:h-5 after:w-5 after:transition-all"
                    [ngClass]="row.isEnabled ? 'bg-[#415CFF] after:translate-x-full after:border-white' : 'bg-gray-200 dark:bg-gray-700'"
                    (click)="onToggleRowClick(row)">
                </button>

            </div>

        </div>
    </div>

    <button type="button"
        class="flex items-center gap-2 bg-[#090909] text-white font-[500] px-4 py-2 rounded-lg mt-4 hover:bg-black dark:bg-white dark:text-[#1A1A1A]"
        (click)="openCreateRowModal()">
        <i class="fa-solid fa-plus text-xs"></i>
        Create New Row
    </button>

    <div *ngIf="!hasData" class="flex flex-col items-center w-full h-screen mt-6">
        <div #dchNoRowsAnim class="w-24 h-28"></div>
        <p class="text-[#494949] my-6 dark:text-white">--No Rows Available--</p>
    </div>


</div>

<!-- Create Row confirmation modal -->
<div *ngIf="showCreateRowModal" class="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">

    <div class="relative bg-white dark:bg-[#363636] shadow-lg rounded-xl p-6 pt-12 w-2/7 text-center">

        <div
            class="absolute top-4 left-1/2 -translate-x-1/2 flex items-center justify-center w-9 h-9 rounded-full bg-[#BDCCDD33]">
            <div class="flex items-center justify-center w-6 h-6 rounded-full bg-[#57687B]">
                <i class="fa-solid fa-info text-white text-xs"></i>
            </div>
        </div>

        <p class="text-lg font-[600] text-[#000000] dark:text-white mt-4">
            Create Row Confirmation
        </p>

        <p class="font-[400] text-[#4B5563] dark:text-gray-300 mt-3">
            Do you want to add Row {{ nextRowNo }}?<br>
            The row will be added in a disabled state initially.
        </p>

        <div class="flex justify-center gap-3 mt-6">
            <button type="button"
                class="bg-[#F6F7F9] border min-w-36 border-[#95A1AC] text-[#6B7D8C] font-[600] px-6 py-2 rounded-lg hover:bg-[#dcdcdc]"
                (click)="cancelCreateRow()">
                Cancel
            </button>

            <button type="button"
                class="bg-[#415CFF] min-w-36 text-white font-[600] px-6 py-2 rounded-lg hover:bg-[#324ae0]"
                (click)="confirmCreateRow()">
                Create Row
            </button>
        </div>
    </div>
</div>


<!-- Create position confirmation modal -->
<div *ngIf="showCreatePositionModal" class="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">

    <div class="relative bg-white dark:bg-[#363636] shadow-lg rounded-xl p-6 pt-12 w-2/7 text-center">

        <div
            class="absolute top-4 left-1/2 -translate-x-1/2 flex items-center justify-center w-9 h-9 rounded-full bg-[#BDCCDD33]">
            <div class="flex items-center justify-center w-6 h-6 rounded-full bg-[#57687B]">
                <i class="fa-solid fa-info text-white text-xs"></i>
            </div>
        </div>

        <p class="text-lg font-[600] text-[#000000] dark:text-white mt-4">
            Create Position Confirmation
        </p>

        <p class="font-[400] text-[#4B5563] dark:text-gray-300 mt-3">
            Do you want to add packing Position {{ (this.currentRow.positions.length - 2) + 1 }} to Row {{
            this.currentRow.rowIndex }}?
        </p>

        <div class="flex justify-center gap-3 mt-6">
            <button type="button"
                class="bg-[#F6F7F9] border min-w-36 border-[#95A1AC] text-[#6B7D8C] font-[600] px-6 py-2 rounded-lg hover:bg-[#dcdcdc]"
                (click)="cancelCreatePos()">
                Cancel
            </button>

            <button type="button"
                class="bg-[#415CFF] min-w-36 text-white font-[600] px-6 py-2 rounded-lg hover:bg-[#324ae0]"
                (click)="createNextPosNo()">
                Create
            </button>
        </div>
    </div>
</div>

<!-- Delete position confirmation modal -->
<div *ngIf="showDeletePositionModal" class="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">

    <div class="relative bg-white dark:bg-[#363636] shadow-lg rounded-xl p-6 pt-12 w-2/7 text-center">

        <div
            class="absolute top-4 left-1/2 -translate-x-1/2 flex items-center justify-center w-9 h-9 rounded-full bg-[#BDCCDD33]">
            <div class="flex items-center justify-center w-6 h-6 rounded-full bg-[#57687B]">
                <i class="fa-solid fa-info text-white text-xs"></i>
            </div>
        </div>

        <p class="text-lg font-[600] text-[#000000] dark:text-white mt-4">
            Confirm Position Deletion
        </p>

        <p class="font-[400] text-[#4B5563] dark:text-gray-300 mt-3">
            Are you sure you want to delete position {{ positionToDelete.pIndex }} of row {{ currentRow.rowIndex }}?
            <BR>
            This action can not be undone.
        </p>

        <div class="flex justify-center gap-3 mt-6">
            <button type="button"
                class="bg-[#F6F7F9] border min-w-36 border-[#95A1AC] text-[#6B7D8C] font-[600] px-6 py-2 rounded-lg hover:bg-[#dcdcdc]"
                (click)="cancelDeletePosition()">
                Cancel
            </button>

            <button type="button" class="bg-[#FF0000] min-w-36 text-white font-[600] px-6 py-2 rounded-lg "
                (click)="confirmDeletePosition()">
                Delete
            </button>
        </div>
    </div>
</div>

<div *ngIf="openErrorEnableRow" class="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">

    <div class="relative bg-white dark:bg-[#363636] shadow-lg rounded-xl p-6 pt-12 text-center w-full max-w-md">

        <div
            class="absolute top-4 left-1/2 -translate-x-1/2 flex items-center justify-center w-9 h-9 rounded-full bg-red-100">
            <div class="flex items-center justify-center w-6 h-6 rounded-full bg-red-500">
                <i class="fa-solid fa-info text-white text-xs"></i>
            </div>
        </div>

        <p class="text-lg font-[600] text-[#000000] dark:text-white mt-4">
            Action Not Allowed
        </p>

        <p class="font-[400] text-[#4B5563] dark:text-gray-300 mt-3">
            Row {{ removeRowIndex }} cannot be enabled because<br>
            Row {{ removeRowIndex }} has no packing positions.
        </p>

        <div class="flex justify-center gap-3 mt-6">
            <button type="button"
                class="bg-[#F6F7F9] border min-w-36 border-[#95A1AC] text-[#6B7D8C] font-[600] px-6 py-2 rounded-lg hover:bg-[#dcdcdc]"
                (click)="cancelErrorEnableRow()">
                Close
            </button>

        </div>
    </div>
</div>

<div *ngIf="openErrorDisableRow" class="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">

    <div class="relative bg-white dark:bg-[#363636] shadow-lg rounded-xl p-6 pt-12 text-center w-full max-w-md">

        <div
            class="absolute top-4 left-1/2 -translate-x-1/2 flex items-center justify-center w-9 h-9 rounded-full bg-red-100">
            <div class="flex items-center justify-center w-6 h-6 rounded-full bg-red-500">
                <i class="fa-solid fa-info text-white text-xs"></i>
            </div>
        </div>

        <p class="text-lg font-[600] text-[#000000] dark:text-white mt-4">
            Action Not Allowed
        </p>

        <p class="font-[400] text-[#4B5563] dark:text-gray-300 mt-3">
            Row {{ removeRowIndex }} cannot be Disabled because<br>
            Row {{ removeRowIndex }} has assigned targets.
        </p>

        <div class="flex justify-center gap-3 mt-6">
            <button type="button"
                class="bg-[#F6F7F9] border min-w-36 border-[#95A1AC] text-[#6B7D8C] font-[600] px-6 py-2 rounded-lg hover:bg-[#dcdcdc]"
                (click)="cancelErrorDisableRow()">
                Close
            </button>

        </div>
    </div>
</div>

<div *ngIf="openToggleRowPopUpDisable"
    class="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">

    <div class="relative bg-white dark:bg-[#363636] shadow-lg rounded-xl p-6 pt-12 w-2/7 text-center">

        <div
            class="absolute top-4 left-1/2 -translate-x-1/2 flex items-center justify-center w-9 h-9 rounded-full bg-[#BDCCDD33]">
            <div class="flex items-center justify-center w-6 h-6 rounded-full bg-[#57687B]">
                <i class="fa-solid fa-info text-white text-xs"></i>
            </div>
        </div>

        <p class="text-lg font-[600] text-[#000000] dark:text-white mt-4">
            Confirm Row Disable
        </p>

        <p class="font-[400] text-[#4B5563] dark:text-gray-300 mt-3">
            Are you sure you want to disable Row {{ rowToToggle.rowIndex }}? <BR>
            It will not be shown when assigning targets
        </p>

        <div class="flex justify-center gap-3 mt-6">
            <button type="button"
                class="bg-[#F6F7F9] border min-w-36 border-[#95A1AC] text-[#6B7D8C] font-[600] px-6 py-2 rounded-lg hover:bg-[#dcdcdc]"
                (click)="cancelOpenTogglePopupDisable()">
                Cancel
            </button>

            <button type="button"
                class="bg-[#415CFF] min-w-36 text-white font-[600] px-6 py-2 rounded-lg hover:bg-[#324ae0]"
                (click)="confirmToggleRow()">
                Disable
            </button>
        </div>
    </div>
</div>

<div *ngIf="openToggleRowPopUpEnable"
    class="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">

    <div class="relative bg-white dark:bg-[#363636] shadow-lg rounded-xl p-6 pt-12 w-2/7 text-center">

        <div
            class="absolute top-4 left-1/2 -translate-x-1/2 flex items-center justify-center w-9 h-9 rounded-full bg-[#BDCCDD33]">
            <div class="flex items-center justify-center w-6 h-6 rounded-full bg-[#57687B]">
                <i class="fa-solid fa-info text-white text-xs"></i>
            </div>
        </div>

        <p class="text-lg font-[600] text-[#000000] dark:text-white mt-4">
            Confirm Row Enable
        </p>

        <p class="font-[400] text-[#4B5563] dark:text-gray-300 mt-3">
            Do you want to Enable Row {{ rowToToggle.rowIndex }}?
        </p>

        <div class="flex justify-center gap-3 mt-6">
            <button type="button"
                class="bg-[#F6F7F9] border min-w-36 border-[#95A1AC] text-[#6B7D8C] font-[600] px-6 py-2 rounded-lg hover:bg-[#dcdcdc]"
                (click)="cancelOpenTogglePopupEnable()">
                Cancel
            </button>

            <button type="button"
                class="bg-[#415CFF] min-w-36 text-white font-[600] px-6 py-2 rounded-lg hover:bg-[#324ae0]"
                (click)="confirmToggleRow()">
                Enable
            </button>
        </div>
    </div>
</div>

<div *ngIf="openPositionDeleteErrorPopUp"
    class="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">

    <div class="relative bg-white dark:bg-[#363636] shadow-lg rounded-xl p-6 pt-12 text-center w-full max-w-md">

        <div
            class="absolute top-4 left-1/2 -translate-x-1/2 flex items-center justify-center w-9 h-9 rounded-full bg-red-100">
            <div class="flex items-center justify-center w-6 h-6 rounded-full bg-red-500">
                <i class="fa-solid fa-info text-white text-xs"></i>
            </div>
        </div>

        <p class="text-lg font-[600] text-[#000000] dark:text-white mt-4">
            Action Not Allowed
        </p>

        <p class="font-[400] text-[#4B5563] dark:text-gray-300 mt-3">
            Position {{ positionToDelete.pIndex }} cannot be deleted because it has<br>
            assigned products. Please remove the assigned<br>
            products first.
        </p>

        <div class="flex justify-center gap-3 mt-6">
            <button type="button"
                class="bg-[#F6F7F9] border min-w-36 border-[#95A1AC] text-[#6B7D8C] font-[600] px-6 py-2 rounded-lg hover:bg-[#dcdcdc]"
                (click)="cancelPoisitonDeleteErrorPopup()">
                Close
            </button>

        </div>
    </div>
</div>